import { useState, useCallback } from 'react';

export interface IUseBoolean {
	value: boolean;
	isFalse: boolean;
	isTrue: boolean;
	setValue: (value: boolean) => void;
	setFalse: () => void;
	setTrue: () => void;
	toggle: () => void;
}

export const useBoolean = (initial = false): IUseBoolean => {
	const [value, setValue] = useState<boolean>(initial);

	const setTrue = useCallback(() => setValue(true), []);
	const setFalse = useCallback(() => setValue(false), []);
	const toggle = useCallback(() => setValue((prev) => !prev), []);

	return {
		value,
		isFalse: !value,
		isTrue: value,
		setValue,
		setFalse,
		setTrue,
		toggle,
	};
};
